export default __webpack_public_path__ + "static/media/popup-icon-error.5f29e970.svg";